import { useMemo } from 'react';
import { TaskId } from 'api/models';
import { Action, EventType, ObjectType } from 'api/pushes';
import { useIsTaskPaneOptimizationEnabled } from 'hooks/use-feature';
import { useProjectWSUpdates } from 'hooks/use-project-ws-updates';
import {
  useTaskDetailQuery,
  useTaskDetailsDefaultFieldsQuery,
  useTaskPaneUpdate,
} from 'queries/task';

/**
 *
 * @deprecated Use `TasksStore.ofId`. Additional information like attachments
 * should come from other stores.
 *
 *
 * only write the partucular task's specific functionality here
 * anything else go write somewhere else
 * dont come here
 */
export const useTaskDetailStore = (taskId: TaskId) => {
  const [, projectId, tId] = taskId;

  const isTaskPaneOptimzationEnabled = useIsTaskPaneOptimizationEnabled();

  const {
    data: taskDetailData,
    isLoading: isTaskDetailLoading,
    ...restOfTheTaskDetailData
  } = useTaskDetailQuery(taskId, {
    // keepPreviousData: true,
    refetchOnMount: true,
    enabled: !isTaskPaneOptimzationEnabled,
  });

  const {
    data: taskDefaultFields,
    isLoading: isTaskDefaultFieldsLoading,
    ...restOfTheTaskDetailFields
  } = useTaskDetailsDefaultFieldsQuery(
    {
      projectId,
      taskId: tId,
    },
    {
      refetchOnMount: true,
      enabled: isTaskPaneOptimzationEnabled,
    },
  );

  const { handleTaskSocketUpdate } = useTaskPaneUpdate(taskId);

  const data = isTaskPaneOptimzationEnabled
    ? taskDefaultFields
    : taskDetailData;
  const isLoading = isTaskPaneOptimzationEnabled
    ? isTaskDefaultFieldsLoading
    : isTaskDetailLoading;
  const rest = isTaskPaneOptimzationEnabled
    ? restOfTheTaskDetailFields
    : restOfTheTaskDetailData;

  useProjectWSUpdates(
    projectId,
    handleTaskSocketUpdate,
    EventType(Action.Update, ObjectType.Task),
  );

  const query = useMemo(
    () => ({
      data: (data
        ? {
            ...data,
            project: data?.project?.projectId,
            subTasks: data?.subTasks?.map((e) => e?.taskId),
            // dependentTasks: data?.dependentTasks?.map((e) => e?.taskId),
          }
        : data) as import('data/tasks/schema').Task | undefined,
      isLoading,
      ...rest,
    }),
    [data, isLoading, rest],
  );

  return query;
};
